import React from "react";
import Dashboard from "../component/Dashboard";

const DashboardContainer = () => (<Dashboard />)

export default DashboardContainer;